import angular from 'angular'

import envRaw from '../utils/env-raw'
import Emitter from '../utils/emitter'

import { offEvent, onEventPassive } from '../utils/on-event'

angular
  .module('ggs.locale')
  .factory('locale', LocaleProvider)

function LocaleProvider(
  qh,
  $rootScope,
  StayInQueue,
  DefineMethod,
  DefineHandler,
  localeDateInternal,
  localeNumberInternal) {

  const sign = 'locale'
  const service = {
    wrapM: DefineMethod(sign),
    wrapH: DefineHandler(sign),
    emitter: Emitter(sign),
    // dates
    fromTime: localeDateInternal.fromTime,
    longDateTime: localeDateInternal.longDateTime,
    shortDateTime: localeDateInternal.shortDateTime,
    // numbers
    shortNumber: localeNumberInternal.shortNumber
  }

  const stayInQueue = StayInQueue(sign)

  let appLocaleGetter = null
  let appLocaleEmitter = null

  service.wrapH('destroyHandler', () => {
    appLocaleGetter = null
    if (appLocaleEmitter) {
      appLocaleEmitter.off(service.localeChangeHandler)
      appLocaleEmitter = null
    }

    offEvent(window, 'languagechange', service.localeChangeHandler)
  })

  service.wrapH('localeChangeHandler', stayInQueue.make(() => {
    return service.syncLocale()
  }))

  service.wrapM('setup', stayInQueue.make((setupGetter, setupEmitter) => {
    appLocaleGetter = setupGetter
    appLocaleEmitter = setupEmitter

    if (envRaw.liveEditMode) {
      return qh.flow(
        service.subscribeOnLocaleChange,
        service.syncLocale)
    } else {
      return service.syncLocale()
    }
  }))

  service.wrapM('syncLocale', () => {
    const appLocale = appLocaleGetter()
    const browserLocale = getBrowserLocale()
    localeDateInternal.changeLocale(appLocale, browserLocale)
    localeNumberInternal.changeLocale(appLocale, browserLocale)
    service.emitter.emit(appLocale, browserLocale)
  })

  service.wrapM('subscribeOnLocaleChange', () => {
    appLocaleEmitter.on(service.localeChangeHandler)
    onEventPassive(window, 'languagechange', service.localeChangeHandler)
  })

  $rootScope.$on('$destroy', service.destroyHandler)
  return service

  function getBrowserLocale() {
    return window.navigator.language
  }
}
